import { render } from "./TaskList.vue?vue&type=template&id=673ed0d4&ts=true"
import script from "./TaskList.ts?vue&type=script&lang=ts&external"
export * from "./TaskList.ts?vue&type=script&lang=ts&external"

import "./TaskList.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__